import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Util } from '../../../../utils/util';
import { TransactionType } from '../../../extract/extract.model';
import { PixHelpComponent } from '../../help/help.component';
import { PixTransaction } from '../../models/transaction.model';
import { PixRefundService } from '../../refund/refund.service';

@Component({
	selector: 'app-pix-extract-details',
	templateUrl: './details.component.html',
	styleUrls: ['./details.component.styl'],
})
export class PixExtractDetailsComponent {

	transactionPix: PixTransaction;

	constructor(
		public dialogRef: MatDialogRef<PixExtractDetailsComponent>,
		private router: Router,
		private refundService: PixRefundService,
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.transactionPix = data;
	}

	getTitle(): string {
		switch (this.transactionPix.tipoTransacao) {
			case TransactionType.PIX_ENVIADO:
				return 'Pagamento Pix';
			case TransactionType.PIX_RECEBIDO:
				return 'Recebimento Pix';
			case TransactionType.PIX_DEVOLUCAO_ENVIADA:
				return 'Devolução Pix';
			case TransactionType.PIX_DEVOLUCAO_RECEBIDA:
				return 'Devolução Pix';
			default:
				return '';
		}
	}

	getSubText(): string {
		return `<b>${Util.formatValue(this.transactionPix.valor)}</b> ${this.getText()} <b>${this.transactionPix.nome}</b>`;
	}

	getText(): string {
		switch (this.transactionPix.tipoTransacao) {
			case TransactionType.PIX_ENVIADO:
				return '&nbsp;foi enviado via Pix para&nbsp;';
			case TransactionType.PIX_RECEBIDO:
				return '&nbsp;foi recebido via Pix de&nbsp;';
			case TransactionType.PIX_DEVOLUCAO_ENVIADA:
				return '&nbsp;foi devolvido para&nbsp;';
			case TransactionType.PIX_DEVOLUCAO_RECEBIDA:
				return '&nbsp;foi devolvido de&nbsp;';
			default:
				return '';
		}
	}

	resume() {
		this.onClose();
		this.router.navigate(['pix/comprovante/' + this.transactionPix.advanced.codigoTransacao + '/pix']);
	}

	showReceipt () {
		return this.transactionPix.tipoTransacao !== TransactionType.PIX_RECEBIDO;
	}

	refund() {
		this.refundService.setPixTransaction(this.transactionPix);
		this.onClose();
		this.router.navigate(['pix/devolver/valor']);
	}

	showRefund = () => this.transactionPix.tipoTransacao === TransactionType.PIX_RECEBIDO;
	onClose = () => this.dialogRef.close();
	onConfirm = () => this.dialogRef.close(true);

	public openHelpModal() : void {
		this.onClose();
		this.dialog.open(PixHelpComponent, {
			width: '400px',
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/extract/details/details.component.ts